import { capitalizeFirstLetter, formatUSCurrency } from 'helpers/formatHelpers'
import { CCLedger, CCPaymentAmountType, CCPaymentMethod } from 'components/features/creditCard/creditCardStore/types'

export const getPaymentMethodTitle = (method: CCPaymentMethod) => {
  const { bank_name, nickname, account_type } = method
  const bankName = !!bank_name ? capitalizeFirstLetter(bank_name) : null
  const accountType = !!account_type ? capitalizeFirstLetter(account_type) : null
  const displayName = !!nickname ? nickname : bankName + ' ' + accountType

  return displayName
}

export const getPaymentAmountTypeTitle = (payment_amount_type: CCPaymentAmountType) => {
  if (!payment_amount_type) {
    return ''
  }
  const suffix = payment_amount_type === 'minimum' ? ' Amount' : ' Balance'

  return capitalizeFirstLetter(payment_amount_type) + suffix
}

export const getAutoPaymentAmount = (payment_amount_type: CCPaymentAmountType, ledger: CCLedger | null) => {
  if (!ledger || !payment_amount_type) {
    return null
  }

  if (payment_amount_type === 'minimum') {
    return formatUSCurrency(ledger.minimum_payment_remaining, 'penny')

  } else if (payment_amount_type === 'current') {
    return formatUSCurrency(ledger.current_balance, 'penny')

  } else if (payment_amount_type === 'statement') {
    return formatUSCurrency(ledger.statement_balance_remaining, 'penny')

  }

  return null
}
